import * as ChangeJuridicalPersonDataTypes from 'src/actions/juridical-person/change-data/Types';
import {
  ChangeJuridicalPersonData,
  ChangeJuridicalPersonDataAction
} from 'src/actions/juridical-person/change-data/ChangePhysicalPersonData.actions';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';

export interface JuridicalPersonFormState {
  juridicalPerson: JuridicalPersonData;
  loading: boolean;
}

const initialState: JuridicalPersonFormState = {
  loading: false,
  juridicalPerson: new JuridicalPersonData({userId: 0})
};

export function JuridicalPersonFormReducer(state: JuridicalPersonFormState = initialState,
                                           action: ChangeJuridicalPersonDataAction): JuridicalPersonFormState {
  switch (action.type) {
    case ChangeJuridicalPersonDataTypes.CHANGE_JURIDICAL_PERSON_DATA:
      const juridicalPerson: JuridicalPersonData = (action as ChangeJuridicalPersonData).payload;
      return {...state, juridicalPerson: juridicalPerson, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/juridical-person/JuridicalPersonFormReducer.tsx